/* eslint-disable react/jsx-props-no-spreading */
import { forwardRef, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box, Button, Dialog, DialogContent, Divider,
  makeStyles, Slide, Typography,
} from '@material-ui/core';
import AssignmentIcon from '@material-ui/icons/Assignment';
import MouseIcon from '@material-ui/icons/Mouse';
import RoomIcon from '@material-ui/icons/Room';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import PropTypes from 'prop-types';

import kami from '../../../../assets/img/KamiBot3D.png';
import { GetCourseById } from '../../../../services/courses';
import { shortFullName } from '../../../../utils';
import CanvaKoin from '../models/CanvaKoin';

const useStyles = makeStyles((theme) => ({
  dialog: {
    background: theme.palette.common.grayLight,
    '& .MuiPaper-root': {
      background: 'transparent',
    },
  },
  dialogContent: {
    background: theme.palette.background.card,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: theme.spacing(5, 6),
    borderRadius: 16,
  },
  containerSectionBot: {
    width: '40%',
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2, 1),
  },
  containerSectionInfo: {
    width: '70%',
  },
  imgKami: {
    width: 180,
  },
  titleDialog: {
    fontFamily: 'Raleway',
    fontSize: '30px',
    fontWeight: 600,
    color: theme.palette.background.info,
    textAlign: 'center',
  },
  subtitleDialog: {
    fontFamily: 'Raleway',
    fontSize: '17px',
    color: theme.palette.text.default,
    textAlign: 'center',
  },
  instructionBoxes: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: theme.spacing(1, 0),
  },
  instructionTitle: {
    fontFamily: 'Raleway',
    fontSize: '22px',
    fontWeight: 700,
    color: theme.palette.common.white,
    textAlign: 'center',
    margin: theme.spacing(3, 0, 0, 0),
  },
  instructionText: {
    fontFamily: 'Raleway',
    fontSize: '14px',
    color: theme.palette.text.default,
    margin: theme.spacing(1, 1, 1, 2),
  },
  divider: {
    background: theme.palette.background.default,
  },
  buttonNext: {
    float: 'right',
    background: theme.palette.background.secondary,
    color: theme.palette.common.white,
    padding: theme.spacing(1, 4),
    fontSize: '14px',
    fontFamily: 'Raleway',
    borderRadius: '9px',
    '&:hover': {
      background: theme.palette.common.pinkLigth,
    },
  },
  buttonBack: {
    float: 'left',
    background: theme.palette.background.secondary,
    color: theme.palette.common.white,
    padding: theme.spacing(1, 4),
    fontSize: '14px',
    fontFamily: 'Raleway',
    borderRadius: '9px',
  },
  instructionIcon: {
    color: theme.palette.common.white,
  },
}));

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

function InitModal({ loading }) {
  const classes = useStyles();
  const params = useParams();
  const { course } = params;
  const [open, setOpen] = useState(true);
  const [show, setShow] = useState(false);
  const [dataOfCourse, setData] = useState('');
  const shortName = shortFullName();

  const handleCloseInitModal = () => {
    // sessionStorage.setItem('noneInit', true);
    setOpen(false);
  };
  const apiGetCourseById = async () => {
    const courseData = await GetCourseById(course);
    setData(courseData.data);
    loading();
  };
  const printNavigationInstructions = () => (
    <Box>
      <Typography className={classes.instructionTitle}>Instrucciones de navegación</Typography>
      <Box>
        <Box className={classes.instructionBoxes}>
          <MouseIcon className={classes.instructionIcon} />
          <Typography className={classes.instructionText}>
            El entorno es interactivo,
            haz click derecho y arrastra
            el mouse para moverte
          </Typography>
        </Box>
        <Divider className={classes.divider} />
        <Box className={classes.instructionBoxes}>
          <RoomIcon className={classes.instructionIcon} />
          <Typography className={classes.instructionText}>
            Haz click en las
            sedes para empezar
            con el desarrollo del tema.
          </Typography>
        </Box>
        <Divider className={classes.divider} />
        <Box className={classes.instructionBoxes}>
          <VolumeUpIcon className={classes.instructionIcon} />
          <Typography className={classes.instructionText}>
            ¡Acompaña tu aprendizaje con música!
            Activa la música haciendo click
            en el icono de la parte derecha.
          </Typography>
        </Box>
        <Divider className={classes.divider} />
        <Box className={classes.instructionBoxes}>
          <AssignmentIcon className={classes.instructionIcon} />
          <Typography className={classes.instructionText}>
            Tendrás tu ruta de
            aprendizaje en la parte
            izquierda de la pantalla.
          </Typography>
        </Box>
        <Button color="secondary" variant="contained" className={classes.buttonNext} onClick={() => setShow(true)}>SIGUIENTE</Button>
      </Box>
    </Box>
  );
  const printKoinsInstructions = () => (
    <Box>
      <Typography className={classes.instructionTitle}>
        {`¡Gana ${dataOfCourse.koins} koins al completar el curso!`}
      </Typography>
      <Box className={classes.instructionBoxes}>
        <Box>
          <Typography className={classes.instructionText}>
            Podrás avanzar al siguiente tema al finalizar todas las lecciones.
            Además, se te darán cierta cantidad de Koins, que posteriormente
            podrás canjear.
          </Typography>
        </Box>
        <CanvaKoin widthValue={100} heightValue={200} />
      </Box>
      <Button
        color="secondary"
        variant="contained"
        onClick={() => {
          setShow(false);
        }}
        className={classes.buttonBack}
      >
        ATRÁS
      </Button>
      <Button
        color="secondary"
        variant="contained"
        className={classes.buttonNext}
        onClick={handleCloseInitModal}
      >
        {' '}
        ¡VAMOS!
      </Button>
    </Box>
  );
  useEffect(() => {
    apiGetCourseById();
  }, []);
  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        fullWidth
        closeAfterTransition
        maxWidth="sm"
        className={classes.dialog}
      >
        <DialogContent className={classes.dialogContent}>
          <Box className={classes.containerSectionBot}>
            <img src={kami} className={classes.imgKami} alt="kamibot" />
          </Box>
          <Box className={classes.containerSectionInfo}>
            <Typography className={classes.titleDialog}>
              {`Hola ${shortName}`}
            </Typography>
            <Typography className={classes.subtitleDialog}>
              {`¡Bienvenid@ al curso de ${dataOfCourse.name}!`}
            </Typography>
            {show ? printKoinsInstructions() : printNavigationInstructions()}
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default InitModal;
InitModal.propTypes = {
  loading: PropTypes.func.isRequired,
};
